module.exports = __webpack_public_path__ + "img/swift-sport.fd4e83d6.svg";